import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
  HostListener
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'tidy-form-popup',
  templateUrl: './form-popup.component.html',
  styleUrls: ['./form-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FormPopupComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() formType: 'input' | 'select' | 'custom' = 'input';
  @Input() saveText = 'Save';
  @Input() cancelText = 'Cancel';
  @Input() header = '';
  @Input() label = '';
  @Input() descriptionText = '';
  @Input() items: any[] = [];
  @Input() initialValue: any = '';
  @Input() icon = '';
  @Input() placeholder = '';

  @Input() saveAction: (value: any) => Promise<void>;
  @Output() cancelAction = new EventEmitter<void>();

  formControl = new FormControl('');
  form = new FormGroup({ value: this.formControl });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && changes['isOpen'].currentValue) {
      this.formControl.setValue(this.initialValue ?? '');
    }
    if (changes['initialValue'] && this.isOpen) {
      this.formControl.setValue(changes['initialValue'].currentValue ?? '');
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.isOpen) {
      this.cancelAction.emit();
    }
  }

  onSave = async (): Promise<void> => {
    if (this.saveAction) {
      await this.saveAction(this.formControl.value);
    }
  }

  onCancel = (): void => {
    this.cancelAction.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    this.cancelAction.emit();
  }
}
